export const AGREEMENT_CREATE_STEPS = [
    'Продукт',
    'Обязательства',
    'Расторжение',
    'Документооборот',
];

export const AGREEMENT_EDIT_STEPS = [
    'Продукт',
    'Обязательства',
    'Расторжение',
];
